import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import ProductOptions from "components/store/ProductOptions";
import Blank from "components/common/Blank";
import shareIcon from "assets/images/icons/ic_share.svg";
import useShare from "hooks/useShare";
import "./ProductInfo.scss";


const ProductInfo = ({
  // type = "lesson",
  product,
  options,
  handleSelectOption,
  purchaseCnt,
  setPurchaseCnt,
  externalPriceDelta = 0,
  hasShareIcon
}) => {
  const { share } = useShare();
  const location = useLocation();
  const pathname = location.pathname;

  const [optionPriceDelta, setOptionPriceDelta] = useState(0);

  // 옵션 가격 변경 핸들러
  const handlePriceChange = (priceDelta) => {
      setOptionPriceDelta(priceDelta);
  };

  // 최종 가격 계산
  const getFinalPrice = () => {
      const delta = externalPriceDelta || optionPriceDelta;
      return (
          (Number(product.discount_price || product.price) +
              Number(delta)) *
          purchaseCnt
      );
  };

  const handleShare = () => {
    share({ title: product?.name || '', appPath: `/product/detail/${product.id}` })
  }

  return (
      <div className="product-info-wrap">
          <h2 className="title">{product.name}</h2>
          <div className="price-wrap">
              <h3 className="price">
                  {product.discount_rate !== null &&
                      product.discount_rate > 0 && (
                          <span className="discount">
                              {Math.floor(product.discount_rate)}%
                          </span>
                      )}
                  {product.discount_price !== null && (
                      <span className="price">
                          {Number(product.discount_price).toLocaleString()}원
                      </span>
                  )}
                  {product.price !== null && product.price !== undefined && (
                      <span
                          className={` ${
                              product.discount_rate === null ||
                              product.discount_rate === 0
                                  ? "price"
                                  : "origin-price"
                          }`}
                      >
                          {Number(product.price).toLocaleString()}원
                      </span>
                  )}
              </h3>
              {hasShareIcon && <img src={shareIcon} alt={`${product.name} 공유 하기`} onClick={handleShare}/>}
          </div>
          {pathname.includes("product") && options && options.length > 0 && (
              <ProductOptions
                  options={options}
                  onOptionChange={handleSelectOption}
                  onPriceChange={handlePriceChange}
              />
          )}
          {!pathname.includes("class") && (
              <p className="purchase-cnt-wrap">
                  <span>구매 수량</span>
                  <div className="cnt-input">
                      <span
                          onClick={() =>
                              purchaseCnt > 1 &&
                              setPurchaseCnt(purchaseCnt - 1)
                          }
                      >
                          -
                      </span>
                      <span className="cnt">{purchaseCnt}</span>
                      <span onClick={() => setPurchaseCnt(purchaseCnt + 1)}>
                          +
                      </span>
                  </div>
              </p>
          )}
          <p className="total-price">
              <span>총 상품금액</span>
              <span className="bold">
                  {Number(getFinalPrice()).toLocaleString()}원
              </span>
          </p>
          {product.free_threshold !== undefined &&
              product.free_threshold !== null && (
                  <p className="free-threshold-wrap">
                      {Number(product.free_threshold).toLocaleString()}원 이상
                      구매 시 무료배송
                  </p>
              )}
          <Blank height={pathname.includes("class") ? 0 : 20} />
      </div>
  );
};

export default ProductInfo;